import 'Lessons/angularModule';
import { statsigClientProvider } from 'StatsigClientProvider';

const learnerContentCacheModule = angular.module('LearnerContentCache', ['FrontRoyal.Lessons']);

learnerContentCacheModule.factory('Statsig', () => statsigClientProvider);

export default learnerContentCacheModule;
